module.exports = __webpack_public_path__ + "img/fast.eb58221f.png";